import { render, staticRenderFns } from "./PortalProductRootMenus.vue?vue&type=template&id=24291428&scoped=true&"
import script from "./PortalProductRootMenus.vue?vue&type=script&lang=ts&"
export * from "./PortalProductRootMenus.vue?vue&type=script&lang=ts&"
import style0 from "./PortalProductRootMenus.vue?vue&type=style&index=0&id=24291428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24291428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VRow,VTooltip})
